import api from './api'

export const getPermissions = async () => {
  const response = await api.get('/auth/permissions')
  return response
}

export const getPermissionById = async (id) => {
  const response = await api.get(`/auth/permissions/${id}`)
  return response
}

export const createPermission = async (data) => {
  const response = await api.post('/auth/permissions', data)
  return response
}

export const updatePermission = async (id, data) => {
  const response = await api.put(`/auth/permissions/${id}`, data)
  return response
}

export const deletePermission = async (id) => {
  const response = await api.delete(`/auth/permissions/${id}`)
  return response
}

export const getSidebarConfig = async () => {
  const response = await api.get('/permissions/sidebar-config')
  return response
}

export const updateSidebarConfig = async (config) => {
  const response = await api.put('/permissions/sidebar-config', config)
  return response
}

export const permissionService = {
  getPermissions,
  getPermissionById,
  createPermission,
  updatePermission,
  deletePermission,
  getSidebarConfig,
  updateSidebarConfig
}